export default __webpack_public_path__ + "static/media/profile-anju.c5e56abe.png";